import React from "react";
import { PrintRecord } from "../../../BlakeData/Types";
import { API } from "../../../BlakeData";
import Micropalette from "../../../Micropalette";

export function PalettePicker(props: {
    width?:number;
    groupID: string;
    prints: Array<PrintRecord>;
}) {

    const palettes = API.makeSwatchArray(props.prints);
    const paletteWidth = props.prints.length > 1 ? 12 : 30,
        padding = 2;

    return (
        <div className="PalettePicker">
            <Micropalette
                height={props.width || 300}
                paletteWidth={paletteWidth}
                padding={padding}
                id={`micropalette-${props.groupID}`}
                palettes={palettes}
                vertical
            ></Micropalette>
            {/* <div>
                Double Slider
            </div> */}
        </div>

    )
}